export default {
      id: "icon--wtw-trainers-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--wtw-trainers-usage",
      toString: function () {
        return this.url;
      }
    }